export type SyvaNeedsFilter = 'fulfilled' | 'identified' | 'unresolved';

export const SYVA_NEEDS_FILTERS: { label: string; value: SyvaNeedsFilter }[] = [
  { label: 'Identified', value: 'identified' },
  { label: 'Fulfilled', value: 'fulfilled' },
  { label: 'Unresolved', value: 'unresolved' },
];
